import { render, staticRenderFns } from "./ColourSettingsInput.vue?vue&type=template&id=5b6e3628&scoped=true"
import script from "./ColourSettingsInput.vue?vue&type=script&lang=js"
export * from "./ColourSettingsInput.vue?vue&type=script&lang=js"
import style0 from "./ColourSettingsInput.vue?vue&type=style&index=0&id=5b6e3628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b6e3628",
  null
  
)

export default component.exports